import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-country-codes',
  templateUrl: './country-codes.component.html',
  styleUrls: ['./country-codes.component.scss']
})
export class CountryCodesComponent implements OnInit {

  @Input() countryCode: string;

  @Output() selectedCountryCode: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
    this.countryCode = "+63";
  }

  protected onChange(countryCode) {
    this.countryCode = countryCode;
    this.selectedCountryCode.emit(this.countryCode);
  }

}
